import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { EditorSpecialFieldsOptions } from "@dev/template-editor";
import { SpecialField } from "@/services/hooks/useEmailTemplateSpecialFields/types";
import { getMergeFieldsStore } from "@/store/mergeFields/actions";
import { PAID_NEWSLETTER_SPECIAL_FIELDS, PAID_NEWSLETTER_SPECIAL_FIELDS_BUTTON } from "../constants";

interface SpecialFieldsProps {
    isButton: boolean
}

export const useSpecialFields = ({ isButton }: SpecialFieldsProps): EditorSpecialFieldsOptions & { fields: SpecialField[] } => {
    const { t } = useTranslation();
    const mergeFields = useSelector(getMergeFieldsStore);

    const specialFields: SpecialField[] = 
        mergeFields?.data?.MergeFields?.
        filter((item) => (isButton? PAID_NEWSLETTER_SPECIAL_FIELDS_BUTTON : PAID_NEWSLETTER_SPECIAL_FIELDS).includes(item.ExactFormat)).
        map(item => ({
            id: item.Id,
            name: item.DisplayName ?? item.Name,
            exactFormat: item.ExactFormat,
            // autocompleteValue: item.ExactFormat,
            isDisabledInButtons: true,
            group: null
        }));

    return {
        title: t('mergefields'),
        startChars: '{',
        endChars: '}',
        fields: specialFields
    };
};
